import { BadgeVariants } from '~backoffice/app/~shared/components/ui/badge/badge.component';
import { ReceiptType } from '~core/models/receipt.models';

export const getReceiptTypeName = (
  value: ReceiptType | undefined | null
): string => {
  if (!value) {
    return '';
  }

  switch (value) {
    case ReceiptType.avoir:
      return "Reçu d'avoir";

    case ReceiptType.normal:
      return 'Reçu de vente';

    case ReceiptType.purchase:
      return 'Reçu APA';

    case ReceiptType.zero:
      return 'Reçu de rechargement';

    default:
      return value;
  }
};

export const getReceiptTypeColor = (
  status: ReceiptType
): BadgeVariants['variant'] => {
  switch (status) {
    case ReceiptType.avoir:
      return 'dangerFancyOutlined';

    case ReceiptType.normal:
      return 'primaryFancyOutlined';

    case ReceiptType.purchase:
      return 'infoFancyOutlined';

    case ReceiptType.zero:
      return 'successFancyOutlined';

    default:
      return 'successFancyOutlined';
  }
};
